import React, { useEffect, useRef, useState } from "react";
import "./ProductsImgComponent.css";
import {
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAngleUp,
  faHeart,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import HeartIconComponent from "../../Common-Component/HeartIconComponent/HeartIconComponent";

const ProductsImgComponent = ({product}) => {
  const swiperRef = useRef(null);
  const [favorite, setFavorite] = useState(false);
  const [swiperInstance, setSwiperInstance] = useState(null);

  const products = [
    {
      image: "/assets/Images/Products/smallImg.png",
    },
    {
      image: "/assets/Images/Products/smallImg.png",
    },
    {
      image: "/assets/Images/Products/smallImg.png",
    },
    {
      image: "/assets/Images/Products/smallImg.png",
    },
    {
      image: "/assets/Images/Products/smallImg.png",
    },
    {
      image: "/assets/Images/Products/smallImg.png",
    },
    {
      image: "/assets/Images/Products/smallImg.png",
    },
    {
      image: "/assets/Images/Products/smallImg.png",
    },
    {
      image: "/assets/Images/Products/smallImg.png",
    },
    {
      image: "/assets/Images/Products/smallImg.png",
    },
    {
      image: "/assets/Images/Products/smallImg.png",
    },
    {
      image: "/assets/Images/Products/smallImg.png",
    },
  ];

  const mainImg = "/assets/Images/Products/bigImg.png";

  const handleMainSliderClick = (direction) => {
    if (!swiperInstance) {
      console.warn("Swiper instance not available yet!");
      return;
    }
  
    if (direction === "prev") {
      swiperInstance.slidePrev();
    } else if (direction === "next") {
      swiperInstance.slideNext();
    }
  };
  const [mainImage, setMainImage] = useState();
  const handleMainImage = (image) => {
    setMainImage(image);
  };

  useEffect(() => {
 
    if (product?.Product_Images?.length > 0) {
        setMainImage(process.env.REACT_APP_IMG_URL+product.Product_Images[0].image);
    } else {
        setMainImage(null);
    }
}, [product]);

  return (
    <section className="ProductsImgComponent">
      {/* vertical swiper */}
      <div className="vertical_slider">
        <Swiper
          ref={swiperRef}
          spaceBetween={15}
          modules={[Navigation]}
          onSwiper={(swiper) => {
            setSwiperInstance(swiper); 
          }}
          autoplay={{ delay: 300 }}
          direction="vertical"
          className="mySwiper"
          loop={true}
          breakpoints={{
            0: {
              slidesPerView: 1,
            },
            340: {
              slidesPerView: 1.2,
              spaceBetween: 5,
            },
            420: {
              slidesPerView: 1.4,
              spaceBetween: 5,
            },
            486: {
              slidesPerView: 2,
              spaceBetween: 5,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 10,
            },
            992: {
              slidesPerView: 4,
              spaceBetween: 5,
            },
            1200: {
              slidesPerView: 3,
              spaceBetween: 10,
            },
            1400: {
              slidesPerView: 4,
              spaceBetween: 10,
            },
          }}
        >
          {product?.Product_Images?.map((slide, index) => (
            <SwiperSlide key={index}>
              <div className="images_slide_div" onClick={() => handleMainImage(process.env.REACT_APP_IMG_URL + slide?.image)}>
                <div className="img_holder">
                  <img src={process.env.REACT_APP_IMG_URL+slide?.image} className="inner_img" />
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <div className="silder-btn">
          <div
            className="back-btn"
            onClick={() => handleMainSliderClick("prev")}
          >
            <FontAwesomeIcon icon={faAngleUp} />
          </div>
          <div
            className="next-btn"
            onClick={() => handleMainSliderClick("next")}
          >
            <FontAwesomeIcon icon={faAngleDown} />
          </div>
        </div>
      </div>

      <div className="main_product_img_div">
        <div className="product_img_holder">
          <img src={mainImage} className="product_img" />
        </div>

        <div className="heart_icon_holder_div">
          {/* <FontAwesomeIcon icon={faHeart} className={`heart_icon ${favorite ? "active" : ""}`} onClick={() => setFavorite(!favorite)} /> */}
          <HeartIconComponent product_id={product?.id} />
        </div>
      </div>

      {/* Horizontal swiper */}

      <div className="horizontal_slider">
        <Swiper
          ref={swiperRef}
          spaceBetween={15}
          modules={[Navigation]}
          onSwiper={setSwiperInstance}
          autoplay={{ delay: 300 }}
          className="mySwiper"
          breakpoints={{
            0: {
              slidesPerView: 3.5,
              spaceBetween: 5,
            },
            340: {
              slidesPerView: 4,
              spaceBetween: 5,
            },
            420: {
              slidesPerView: 5,
              spaceBetween: 5,
            },
            486: {
              slidesPerView: 6,
              spaceBetween: 5,
            },
            768: {
              slidesPerView: 4,
              spaceBetween: 10,
            },
            992: {
              slidesPerView: 4,
              spaceBetween: 5,
            },
            1200: {
              slidesPerView: 3,
              spaceBetween: 10,
            },
            1400: {
              slidesPerView: 4,
              spaceBetween: 10,
            },
          }}
        >
          {product?.Product_Images?.map((slide, index) => (
            <SwiperSlide key={index} >
              <div className="images_slide_div" onClick={() => handleMainImage(process.env.REACT_APP_IMG_URL + slide?.image)}>
                <div className="img_holder">
                  <img src={process.env.REACT_APP_IMG_URL+slide?.image} className="inner_img" />
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <div className="silder-btn">
          <div
            className="next-btn"
            onClick={() => handleMainSliderClick("next")}
          >
            <FontAwesomeIcon icon={faAngleLeft} />
          </div>

          <div
            className="back-btn"
            onClick={() => handleMainSliderClick("prev")}
          >
            <FontAwesomeIcon icon={faAngleRight} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductsImgComponent;
